'use strict';

import { Mesh, ShaderMaterial, Vector2 } from 'three';
import vertex from './vertex.glsl';
import fragment from './fragment.glsl';
import {Cloudflare} from "../../../api/Cloudflare";

export class Trees {
    #active = config.features.liteMode.settings.trees?.active;
    #speed = config.features.liteMode.settings.trees?.speed || 0.2;
    #turbulence = config.features.liteMode.settings.trees?.turbulence || 0.001;
    #scale = config.features.liteMode.settings.trees?.scale || { x:50.0, y: 50.0 };
    #offsetX = config.features.liteMode.settings.trees?.offsetX || { x: 100.0, y: 0.0 };
    #offsetY = config.features.liteMode.settings.trees?.offsetY || { x: 300.0, y: 150.0 };
    #url = null;
    #dayTexture = null;
    #nightTexture = null;
    #depthTexture = null;
    #loader = null;
    #material = null;
    #mesh = null;
    #ready = false;

    constructor (url,dayTexture,nightTexture,loader,depthImage) {
        this.#url = `${url}${config.features.liteMode.settings.trees?.path}?v=${Cloudflare.version}` || '';
        this.#dayTexture = dayTexture;
        this.#nightTexture = nightTexture;
        this.#depthTexture = depthImage;
        this.#loader = loader;

        return this;
    }

    create() {
        if (!this.#active) return new Promise(resolve => resolve('disabled'));

        return new Promise(resolve => {
            this.#loader.load(this.#url, model => {
                model.traverse(el => {
                    if (el.isMesh) {
                        const geometry = el.geometry.clone();
                        this.#material = new ShaderMaterial({
                            vertexShader: vertex,
                            fragmentShader: fragment,
                            uniforms: {
                                generalTexture: {
                                    value: this.#dayTexture
                                },
                                nightGeneralTexture: {
                                    value: this.#nightTexture
                                },
                                depthTexture: {
                                    value: this.#depthTexture
                                },
                                uSpeed: {
                                    value: this.#speed
                                },
                                uTurbulence: {
                                    value: this.#turbulence
                                },
                                uScale: {
                                    value: new Vector2(this.#scale.x,this.#scale.y)
                                },
                                uOffsetX: {
                                    value: new Vector2(this.#offsetX.x,this.#offsetX.y)
                                },
                                uOffsetY: {
                                    value: new Vector2(this.#offsetY.x,this.#offsetY.y)
                                },
                                uTime: {
                                    value: 0.0
                                },
                                uTimesOfDay: {
                                    value: 0.0
                                },
                                uDepthMouse: {
                                    value: new Vector2()
                                }
                            },
                            depthTest: false,
                            depthWrite: false,
                            transparent: true,
                            opacity: 1
                        });

                        this.#mesh = new Mesh(geometry,this.#material);
                        this.#mesh.name = el.name;
                        this.#mesh.scale.copy(el.scale);
                        this.#mesh.position.set(0,0,-0.2);

                        this.#ready = true;
                        resolve(this.#mesh);
                    }
                });
            });
        });

    }

    updateDepthPosition(vec2) {
        this.#material?.uniforms.uDepthMouse.value.set(vec2.x,vec2.y);
    }

    updateTime(time) {
        if (this.#ready) {
            this.#material.uniforms.uTime.value += time;
        }
    }

    updateTimesOfDay(time){
        if (this.#ready) {
            this.#material.uniforms.uTimesOfDay.value = time;
        }
    }

    switcher(state) {
        if (this.#ready) {
            switch (state) {
                case 'show':
                    this.#mesh.visible = true;
                    break;
                case 'hide':
                    this.#mesh.visible = false;
                    break;

            }
        }
    }

}